import { render, staticRenderFns } from "./AddNewUploads.vue?vue&type=template&id=91ed486a"
import script from "./AddNewUploads.vue?vue&type=script&lang=js"
export * from "./AddNewUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports